import React from 'react';
import PropTypes from 'prop-types';
import { RESIZE_URL } from 'utils/restapi';

import './MusicLinkThumbnail.css';

const MusicLinkThumbnail = ({ itemThumbnail }) => {
  return (
    <div
      className="music-link-thumbnail__component"
      style={itemThumbnail && { backgroundImage: `url(${itemThumbnail})` }}
    />
  );
};

MusicLinkThumbnail.propTypes = {
  itemThumbnail: PropTypes.string,
};
MusicLinkThumbnail.defaultProps = {
  itemThumbnail: null,
};

export default MusicLinkThumbnail;
